import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { Box, Typography, Modal } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import { AdminTouchpointsList } from "./components/TouchpointsList";
import AdminTouchpointHttpClient from "../../../core/infrastructure/clients/v2/AdminTouchpointHttpClient";
import { TouchpointForm } from "./components/TouchpointForm";

export const AdminTouchpoints = () => {
    const { project, reloadProjectData } = useOutletContext<any>();
    const { getAccessTokenSilently } = useAuth0();
    const [touchpoints, setTouchpoints] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [createMode, setCreateMode] = useState(false);
    const client = new AdminTouchpointHttpClient();

    const fetchTouchpoints = async () => {
        setLoading(true);
        const accessToken = await getAccessTokenSilently();
        const { data, error } = await client.getTouchpointsByProjectId(accessToken, project.id);
        
        if (data) {
            setTouchpoints(data.touchpoints);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (project) {
            fetchTouchpoints();
        }
    }, [project]);

    const handleClose = () => {
        setCreateMode(false);
        fetchTouchpoints();
    }

    return (
        <div className="admin-screen">
            <div className="admin-table-header">
                <h5>Nurture</h5>
                <button className="btn btn-primary" onClick={() => setCreateMode(true)}>
                    Create New Touchpoint
                </button>
            </div>
            
            <Modal 
                open={createMode} 
                onClose={handleClose}
            >
                <Box>

                    <TouchpointForm
                        project={project}
                        editMode={createMode}
                        setEditMode={setCreateMode}
                        reloadTouchpoints={fetchTouchpoints}
                    />
                </Box>
            </Modal>

            <AdminTouchpointsList
                project={project}
                sectionName="Draft"
                touchpoints={touchpoints.filter((t: any) => t.status === "draft")}
                reloadTouchpoints={fetchTouchpoints}
            />

            <AdminTouchpointsList
                project={project}
                sectionName="Scheduled"
                touchpoints={touchpoints.filter((t: any) => t.status === "scheduled")}
                reloadTouchpoints={fetchTouchpoints}
            />

            <AdminTouchpointsList
                project={project}
                sectionName="Active"
                touchpoints={touchpoints.filter((t: any) => t.status === "active")}
                reloadTouchpoints={fetchTouchpoints}
            />

            <AdminTouchpointsList
                project={project}
                sectionName="Completed"
                touchpoints={touchpoints.filter((t: any) => t.status === "completed")}
                reloadTouchpoints={fetchTouchpoints}
            />
        </div>
    );
}; 